var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"value":_vm.value,"placeholder":"请选择渠道","clearable":""},on:{"change":_vm.change}},_vm._l((['是','否','禁']),function(item){return _c('el-option',{key:item,attrs:{"label":item,"value":item}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }